import React from "react";
import ReactHtmlParser from "react-html-parser";
import CustomTooltip from "src/components/Tooltip";
import * as S from "./styles";

function Item({ item, last, first }) {
  const { image, title, description } = item;

  const tooltipText = {
    title:
      "A recarga automática é uma facilidade para você nunca ficar sem saldo!",
    description:
      "Você escolhe o valor para sua primeira recarga, a partir de R$50. Sempre que o saldo da conta chegar em 30%, nós recarregaremos automaticamente no cartão cadastrado. Você também pode acessar o app Veloe e realizar uma recarga adicional de forma manual apenas para compor saldo, se achar necessário.",
  };

  const text = "<span>Entenda o que é recarga automática{icon}</span>";

  const textWithIcon = (text) => {
    return text.replace(
      "{icon}",
      '<img src="/tagnext/assets/info_icon_darkgreen.svg" />'
    );
  };

  return (
    <S.Container>
      <S.Image>
        <img
          src={`https://${image.fields.file.url}`}
          alt={image.fields.title}
        />
      </S.Image>
      <S.Content>
        <S.Title>{title}</S.Title>
        <S.Description>{description}</S.Description>
      </S.Content>
      {first && (
        <CustomTooltip
          title={tooltipText.title}
          description={tooltipText.description}
          label={
            <S.TooltipLink>{ReactHtmlParser(textWithIcon(text))}</S.TooltipLink>
          }
        />
      )}
      {last && (
        <S.LinkFooter
          href="https://veloe.com.br/onde-usar/mapa/"
          target="blank"
        >
          Ver cobertura
        </S.LinkFooter>
      )}
    </S.Container>
  );
}

export default Item;
